import exportStockOutSummary from "./export-stockout-summary.api";
import getStockOutSummary from "./get-stockout-summary.api";

const stockoutApi = {
  exportStockOutSummary,
  getStockOutSummary,
};
export default stockoutApi;
